module.exports = "/_next/static/images/privacy@2x-477deab1932958e2f1a1b08160ad6abd.png";